import { IRBDItem } from '../../../../models/rbd';

export const SELECTOR = {
    ELEMENT: 'element',
    TRANMISSION: 'transmission',
    TRANSMISSION_ELEMENTS: 'transmission.elements',
    ITEM_TYPE: 'itemType',
    TRANSMISSION_TYPE: 'transmission.transmissionType',
    ELEMENT_NAME: 'element.name',
    ELEMENT_TAGNUMBER: 'element.tagNumber',
    SEQUENCE: 'sequence'
}



/**
 * Find value in the object by passing selector as second argument.
 * finder have two required arguments
 * 
 * @param obj - IRBDItem type
 * @param selector - string
 * @returns any
 */
const finder = (obj: IRBDItem, selector: string) => {
    const result = selector
        .replace(/\[([^[\]]*)\]/g, '.$1.')
        .split('.')
        .filter((t: any) => t !== '')
        .reduce((prev: any, cur: any) => prev && prev[cur], obj)
    return result
}
export default finder;



/**
 * find text from RBDItemWithParent object
 * 
 * @param obj 
 * @returns 
 */
export const findText = (obj: IRBDItem) => 
    finder(obj, SELECTOR.ELEMENT_NAME) 
        ? finder(obj, SELECTOR.ELEMENT_NAME) 
        : finder(obj, SELECTOR.ELEMENT_TAGNUMBER)
